<h2>{{ field.parent.parent.parent.props.label }}</h2> <!-- Tab title to which the form summary field belongs -->
<div *ngIf="field.parent.parent.parent.props.formSummaryDescription != null">
  {{ field.parent.parent.parent.props.formSummaryDescription }}
  <!-- Tab formSummaryDescription to which the form summary field belongs -->
</div>

<div class="p-invalid mb-3" *ngIf="hasAnySystemIneligibleReason()">
  <b>Application Ineligible:</b> {{ getSystemIneligibleReason() }}
</div>

<div class="p-invalid mb-3" *ngIf="hasAnyFailedBlockValidationMessages()">
  One or more trips in your claim did not meet the block treatment criteria and were not approved. The remaining
  eligible trips have been successfully processed.
</div>

<dl class="grid" *ngIf="hasAnyBlockValidationMessages()">
  <div class="col-12">
    <dspx-heading [level]="3" heading="Trip outcome messages"></dspx-heading>
    <p-table [value]="getBlockValidationSummary()" [paginator]="false">
      <ng-template pTemplate="header">
        <tr>
          <th>Trip ID</th>
          <th>Date</th>
          <th>Distance</th>
          <th>Message</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-row>
        <tr>
          <td>{{ row.id }}</td>
          <td>{{ row.date }}</td>
          <td>{{ row.distance }}</td>
          <td>{{ row.message }}</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</dl>

<dl class="grid" *ngIf="hasAnyStandardValidationMessages()">
  <div class="col-12">
    <dspx-heading [level]="3" heading="Trip outcome messages"></dspx-heading>
    <p-table [value]="getStandardValidationSummary()" [paginator]="false">
      <ng-template pTemplate="header">
        <tr>
          <th>Date</th>
          <th>Transport Type</th>
          <th>Accommodation</th>
          <th>Message</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-row>
        <tr>
          <td>{{ row.date }}</td>
          <td>{{ row.transportType }}</td>
          <td>{{ row.accommodationName }}</td>
          <td>{{ row.message }}</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</dl>

<div class="summary-section mt-6" *ngIf="getIscoPaymentRequired() == true">
  <hr>
  <dspx-heading [level]="2" heading="Contribution required for non-concession card holders?"></dspx-heading>
  <div id="thedesc" class="field field--paragraph" data-field-type="paragraph">
    <p>{{ getIscoPaymentRequired() ? "Yes": "No" }}</p>
  </div>
</div>

<dl class="grid" *ngIf="hasSubsidiesPayableResults()">
  <div class="col-12">
    <dspx-heading [level]="3" heading="Subsidies Payable"></dspx-heading>
    <p-table [value]="getSubsidiesPayableResults()" [paginator]="false">
      <ng-template pTemplate="header">
        <tr>
          <th>Travel Category</th>
          <th>Payee</th>
          <th>Subsidy</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-row>
        <tr>
          <td>{{ row.glCode }}</td>
          <td>{{ row.payee }}</td>
          <td>{{ row.subsidy | currency:'AUD':'symbol':'1.2-2' }}</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</dl>

<div class="summary-section mt-6" *ngFor="let tab of getFormConfig(); let tabIndex = index">
  <!-- Start of tab -->
  <hr>
  <dspx-heading *ngIf="props.showPageLink" [level]="2" [heading]="tab.props.label"></dspx-heading>
  <div *ngFor="let page of tab.fieldGroup; let pageIndex = index;">
    <!-- Start of page -->
    <ng-container *ngIf="showPageInSummary(page)">
      <!-- Page heading -->
      <div class="flex">
        <button *ngIf="props.showPageLink" type="button" pButton pRipple
          [attr.aria-expanded]="page.props.summaryHidden ? false : true"
          (click)="page.props.summaryHidden = !page.props.summaryHidden"
          class="my-0 p-button-text p-button-rounded p-button-plain" id="form-summary-{{tabIndex}}-{{pageIndex}}"
          [icon]="page.props.summaryHidden ? 'pi pi-chevron-right' : 'pi pi-chevron-down'">
          <span class="sr-only">{{tab.props.label}}</span>
        </button>
        <dspx-heading [level]="getPageHeadingLevel()" [heading]="page.props.label"></dspx-heading>
        <a *ngIf="props.showPageLink" role="link" tabindex="0" class="page-link" title="{{getPageLinkLabel(page)}}"
          (click)="goToPage(tab, page)" (keydown.enter)="goToPage(tab, page)" (keydown.space)="goToPage(tab, page)">
          <i [ngClass]="getPageLinkIcon(page)"></i>
          <span>{{getPageLinkLabel(page)}}</span>
        </a>
      </div>

      <!-- Non-repeating page -->
      <ng-container *ngIf="isPageType(page.type)">
        <div *ngIf="page.props.summaryHidden !== true">
          <div *ngIf="page.props.formSummaryDescription != null" class="summary-paragraph">
            {{ page.props.formSummaryDescription }}
          </div>
          <dspx-validation-summary *ngIf="page.props?.isEditable && props.showValidationSummary"
            [pageField]="page"></dspx-validation-summary>
          <div *ngFor="let section of getFieldGroup(page); let sectionIndex = index">
            <!-- Start of section -->
            <ng-container *ngIf="section.hide !== true && showSectionBasedOnCondition(section)">
              <!-- Section heading -->
              <ng-container *ngIf="section.type !== 'section-verification'">
                <dspx-heading [level]="3" [heading]="section.props.label"></dspx-heading>
              </ng-container>

              <div *ngIf="section.props.formSummaryDescription != null" class="summary-paragraph">
                {{ section.props.formSummaryDescription }}
              </div>

              <!-- Non-repeating section -->
              <dl *ngIf="isSectionType(section.type) || section.type === 'section-verification'" class="grid">
                <div *ngFor="let question of getFieldGroup(section);" [ngClass]="{
                          'display-none': question.props.hideOnSummary === true ||
                                          getFieldVisibility(question, tab.key, page.key, -1, section.key, -1) === false ||
                                          question.type === 'paragraph' ||
                                          question.type === 'information' ||
                                          question.type === 'summary' ||
                                          question.props.label == null,
                          'col-12 md:col-12 mb-6': question.type === 'checkbox',
                          'col-12 md:col-6 mb-3': question.type !== 'checkbox'
                        }">
                  <dt class="label mb-2">{{ question.props.label }}</dt>
                  <dd class="ml-0">
                    <div innerHTML="{{ getResponse(question, tab.key, page.key, -1, section.key, -1) }}"></div>
                  </dd>
                  <div class="p-invalid">
                    {{ getValidationErrorText(question, tab.key, page.key, -1, section.key, -1) }}
                  </div>
                </div>
                <p-divider></p-divider>
              </dl>

              <!-- Repeating section-->
              <dl *ngIf="isPageType(page.type) && isRepeatingSectionType(section.type)">
                <ng-container
                  *ngTemplateOutlet="repeatingSections; context {$implicit: getFieldGroup(section), tableData: getSectionInstanceArray(tab.key, page.key, -1, section.key), tab: tab, page: page, pageindex: -1, section: section}">
                </ng-container>
              </dl>
            </ng-container>
          </div>
        </div>
      </ng-container>
      <!-- End of non-repeating page -->

      <!-- Repeating page -->
      <ng-container *ngIf="isRepeatingPageType(page.type)">
        <div *ngIf="page.props.summaryHidden !== true">
          <div *ngFor="let repeatingPageIndex of getPageInstanceArray(tab.key, page.key);">
            <div *ngIf="page.props.formSummaryDescription != null" class="summary-paragraph">
              {{ page.props.formSummaryDescription }}
            </div>
            <dspx-validation-summary *ngIf="page.props?.isEditable && props.showValidationSummary"
              [pageField]="page"></dspx-validation-summary>
            <div *ngFor="let section of getFieldGroup(page); let sectionIndex = index">
              <!-- Start of section -->
              <ng-container *ngIf="section.hide !== true">
                <!-- Section heading -->
                <ng-container
                  *ngIf="section.type === 'section-verification' && getSectionVisibility(section, tab.key, page.key, repeatingPageIndex, section.key, -1) !== false; else repeatingPageSectionHeading">
                  <dspx-heading [level]="3" [heading]="section.props.label"></dspx-heading>
                </ng-container>
                <ng-template #repeatingPageSectionHeading>
                  <dspx-heading [level]="3" [heading]="section.props.label"></dspx-heading>
                </ng-template>

                <div *ngIf="section.props.formSummaryDescription != null" class="summary-paragraph">
                  {{ section.props.formSummaryDescription }}
                </div>

                <!-- Non-repeating section -->
                <dl *ngIf="isSectionType(section.type) || section.type === 'section-verification'" class="grid">
                  <div class="col-12">
                    <ng-container
                      *ngIf="getRepeatingPageHeaderText(section, tab.key, page.key, repeatingPageIndex, section.key, -1) != null">
                      <dspx-heading [level]="4"
                        [heading]="getRepeatingPageHeaderText(section, tab.key, page.key, repeatingPageIndex, section.key, -1)"></dspx-heading>
                    </ng-container>
                    <div class="grid">
                      <div *ngFor="let question of getFieldGroup(section);" [ngClass]="{'display-none': question.props.hideOnSummary === true
                                  || getFieldVisibility(question, tab.key, page.key, repeatingPageIndex, section.key, -1) === false
                                  || question.type === 'paragraph'
                                  || question.type === 'information'
                                  || question.type === 'summary'
                                  || question.props.label == null,
                                  'col-12 md:col-12 mb-6': question.type === 'checkbox',
                                  'col-12 md:col-6 mb-3': question.type !== 'checkbox'
                                }">
                        <div class="col pt-3 pb-3">
                          <dt class="label mb-2">{{ question.props.label }}</dt>
                          <dd class="ml-0">
                            <div
                              innerHTML="{{ getResponse(question, tab.key, page.key, repeatingPageIndex, section.key, -1) }}">
                            </div>
                          </dd>
                          <div class="p-invalid">
                            {{ getValidationErrorText(question, tab.key, page.key, repeatingPageIndex, section.key, -1)
                            }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </dl>

                <!-- Repeating section-->
                <dl *ngIf="isRepeatingSectionType(section.type)" class="grid">
                  <div class="col-12">
                    <ng-container
                      *ngTemplateOutlet="repeatingSections; context {$implicit: getFieldGroup(section), tableData: getSectionInstanceArray(tab.key, page.key, repeatingPageIndex, section.key), tab: tab, page: page, pageindex: repeatingPageIndex, section: section}">
                    </ng-container>
                  </div>
                </dl>
              </ng-container>
            </div>
          </div>
        </div>
      </ng-container>
      <!-- End of repeating page -->

      <!-- Removing based on accessibility testing feedback, keeping the code commented if we need to add this again
      <div *ngIf="props.showPageLink" class="mb-3">
        <button type="button" pButton pRipple class="p-button-primary p-button-text" tabindex="0" title="Hide answers"
                (click)="hidePage(page, tabIndex, pageIndex)" icon="pi pi-chevron-up" label="Hide answers"></button>
      </div> -->

    </ng-container>
    <!-- End of page -->
  </div>
  <!-- End of tab -->
</div>

<dl class="grid">
  <div class="col-12">
    <dspx-heading [level]="3" heading="Declaration"></dspx-heading>
    <formly-form [model]="model" [fields]="summaryPageDeclarationFields" [options]="options"
      [form]="form"></formly-form>
  </div>
</dl>


<ng-template #sectionQuestions let-class="class" let-containerClass="containerClass" let-section="section"
  let-tabKey="tabKey" let-pageKey="pageKey" let-repeatingPageIndex="repeatingPageIndex" let-sectionKey="sectionKey"
  let-repeatingSectionIndex="repeatingSectionIndex">
  <div *ngFor="let question of getFieldGroup(section);" class="{{class}}" [ngClass]="{'display-none': question.props.hideOnSummary === true
                                  || getFieldVisibility(question, tabKey, pageKey, repeatingPageIndex, sectionKey, repeatingSectionIndex) === false
                                  || question.type === 'paragraph'
                                  || question.type === 'information'
                                  || question.type === 'summary'
                                  || question.props.label == null}">
    <div class="{{containerClass}}">
      <dt class="label mb-2">
        {{ question.props.label }}
        <span *ngIf="question.props.required && question.props.hideRequiredMarker !== true" aria-hidden="true">*</span>
        <button *ngIf="isQuickEditEnabled(question)" type="button" pButton pRipple
          (click)="showQuickEdit(question, tabKey, pageKey, repeatingPageIndex, sectionKey, repeatingSectionIndex)"
          class="p-button-text p-button-rounded quick-edit-button" icon="fas fa-pen"></button>
      </dt>
      <dd class="ml-0">
        <dspx-show-hide-text
          text="{{ getResponse(question, tabKey, pageKey, repeatingPageIndex, sectionKey, repeatingSectionIndex) }}"></dspx-show-hide-text>
      </dd>
      <div class="p-invalid">
        {{ getValidationErrorText(question, tabKey, pageKey, repeatingPageIndex, sectionKey, repeatingSectionIndex) }}
      </div>
    </div>
  </div>
</ng-template>
<ng-template #repeatingSections let-questions let-tableData="tableData" let-tab="tab" let-page="page"
  let-pageindex="pageindex" let-section="section">
  <p-table [value]="tableData">
    <ng-template pTemplate="header">
      <tr>
        <ng-container *ngFor="let col of questions">
          <th [ngClass]="{'display-none': col.props.hideOnSummary === true
             || col.type === 'paragraph'
             || col.type === 'information'
             || col.type === 'summary'
             || col.props.label == null}">
            {{col.props?.label}}
          </th>
        </ng-container>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-record>
      <tr>
        <ng-container *ngFor="let col of questions">
          <td [ngClass]="{'display-none': col.props.hideOnSummary === true
              || col.type === 'paragraph'
              || col.type === 'information'
              || col.type === 'summary'
              || col.props.label == null}">
            @if (col.type === 'file'){
            <ng-container
              *ngTemplateOutlet="uploadFilesDownloadLinks; context {$implicit: getUploadedFiles(col, tab.key, page.key, pageindex, section.key, record.index), question: col}">
            </ng-container>
            }
            @else {
            <div innerHTML="{{ getResponse(col, tab.key, page.key, pageindex, section.key, record.index) }}"></div>
            <div class="p-invalid">
              {{ getValidationErrorText(col, tab.key, page.key, pageindex, section.key, record.index) }}
            </div>
            }
          </td>
        </ng-container>
      </tr>
    </ng-template>
  </p-table>
</ng-template>
<ng-template #uploadFilesDownloadLinks let-data let-question="question">
  <!--show download link-->
  <ng-container *ngIf="data">
    <ng-container *ngFor="let file of data">
      <div class="col-12">
        <div class="filename" (click)="downloadFile(file, question.key)" role="button" [id]="'button-' + file"
          [aria-label]="'Click here to download ' + file">
          {{ file.name }}
        </div>
        <div class="button-container">
          <button pButton type="button" class="p-button-primary p-button-text" label="Download" title="Download"
            icon="fas fa-download" (click)="downloadFile(file, question.key)"></button>
        </div>
      </div>
    </ng-container>
  </ng-container>
</ng-template>
<p-dialog *ngIf="showQuickEditPopup" [(visible)]="showQuickEditPopup" modal="true" styleClass="dialog"
  [baseZIndex]="10000" focusTrap="true" closeAriaLabel="Close">
  <ng-template pTemplate="header">
    <h2 class="p-dialog-title" tabindex="-1" autofocus>{{getQuickEditPopupLabel()}}</h2>
  </ng-template>
  <ng-template pTemplate="content">
    <div class="dialog-form">
      <form [formGroup]="quickEditForm">
        <formly-form [form]="quickEditForm" [fields]="quickEditQuestions" [model]="quickEditModel"></formly-form>
      </form>
    </div>
  </ng-template>
  <ng-template pTemplate="footer">
    <p-button (click)="updateQuickEditField()" label="Ok" title="Ok" styleClass="p-button-conversion"></p-button>
    <p-button (click)="closeQuickEditPopup()" label="Cancel" title="Cancel" styleClass="p-button-secondary"></p-button>
  </ng-template>
</p-dialog>